import { render, staticRenderFns } from "./InvitationAcceptScreen.vue?vue&type=template&id=62ba1b4d&scoped=true&"
import script from "./InvitationAcceptScreen.vue?vue&type=script&lang=ts&"
export * from "./InvitationAcceptScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ba1b4d",
  null
  
)

export default component.exports